// extracted by mini-css-extract-plugin
export default {"Page":"index_Page__H+9gB"};